require('../modules/es.parse-float');
var path = require('../internals/path');

module.exports = path.parseFloat;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/core-js/es/parse-float.js
// module id = /4Vp
// module chunks = 0 3